"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12c0-4.9706-4.0294-9-9-9s-9 4.0294-9 9c0 4.4922 3.2912 8.2155 7.5938 8.8907v-6.2891H8.3086V12h2.2852v-1.9828c0-2.2556 1.3436-3.5016 3.3994-3.5016.9847 0 2.0146.1758 2.0146.1758v2.2149h-1.1349c-1.118 0-1.4667.6937-1.4667 1.4054V12h2.4961l-.399 2.6016h-2.0971v6.2891C17.7088 20.2155 21 16.4922 21 12z",
    fill: "#1877F2"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5033 14.6016 15.9023 12h-2.4961v-1.6883c0-.7117.3487-1.4055 1.4667-1.4055h1.1349V6.6914s-1.0299-.1758-2.0146-.1758c-2.0558 0-3.3994 1.246-3.3994 3.5016V12H8.3086v2.6016h2.2852v6.2891A9.066 9.066 0 0 0 12 21a9.066 9.066 0 0 0 1.4062-.1093v-6.2891h2.0971z",
    fill: "#fff"
  })];
};

exports.default = _default;